"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryScreen = void 0;
const uniqid = require("uniqid");
class StoryScreen {
    constructor(data) {
        this.logo = null;
        this.title = "Screen title";
        this.subtitle = "Screen subtitle";
        this.titleColor = "#C41723";
        this.subtitleColor = "#C41723";
        this.backgroundColor = "#C41723";
        this.link = "";
        this.position = 0;
        this.footerButtonText = "VALIDER";
        this.footerButtonTextColor = "#C41723";
        this.footerChevronColor = "#C41723";
        this.footerBgColor = "#C41723";
        if (data && null !== data) {
            this.id = parseInt(data.id);
            this.uuid = data.uuid;
            this.logo = data.logo ? `${data.logo.split('?d=')[0]}?d=${uniqid()}` : null;
            this.title = data.title;
            this.subtitle = data.subtitle;
            this.titleColor = data.titleColor;
            this.subtitleColor = data.subtitleColor;
            this.backgroundColor = data.backgroundColor;
            this.illustration = data.illustration ? `${data.illustration.split('?d=')[0]}?d=${uniqid()}` : null;
            this.link = data.link;
            this.position = parseInt(data.position);
            if (typeof data.footerButtonText === "undefined") {
                this.footerButtonText = data.button_text;
                this.footerButtonTextColor = data.button_textColor;
                this.footerChevronColor = data.button_colorChevron;
                this.footerBgColor = data.button_backgroundColor;
            }
            else {
                this.footerButtonText = data.footerButtonText;
                this.footerButtonTextColor = data.footerButtonTextColor;
                this.footerChevronColor = data.footerChevronColor;
                this.footerBgColor = data.footerBgColor;
            }
        }
        else {
            this.uuid = `${uniqid()}`;
        }
    }
}
exports.StoryScreen = StoryScreen;
//# sourceMappingURL=StoryScreen.js.map